var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconControlBarLikeActive = function SvgIconControlBarLikeActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 34 30"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_control_bar_like_active_svg__a",
    x1: 34,
    x2: 0,
    y1: 15,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05ECE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#00B3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF82FB"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#icon_control_bar_like_active_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.711 9.836A2.39 2.39 0 0 0 9 11.542V26.12C9 28.263 10.685 30 12.765 30h12.492c1.462 0 2.786-.893 3.372-2.275l5.03-11.899c1.168-2.755-.814-5.834-3.73-5.796l-9.17.048a.412.412 0 0 1-.396-.518l1.833-7.26C22.64.517 20.544-.756 19.248.512zM1 10a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1z"
  }))));
};
export default SvgIconControlBarLikeActive;